import { render, staticRenderFns } from "./WeiRenZheng.vue?vue&type=template&id=38b5d4f6&scoped=true"
import script from "./WeiRenZheng.vue?vue&type=script&lang=js"
export * from "./WeiRenZheng.vue?vue&type=script&lang=js"
import style0 from "./WeiRenZheng.vue?vue&type=style&index=0&id=38b5d4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5d4f6",
  null
  
)

export default component.exports